import { Switch } from '@mantine/core';
import React, { useState } from 'react';
import { AiOutlineCar } from 'react-icons/ai';
import { CgChevronDoubleRight } from "react-icons/cg";
import { FaTrash } from 'react-icons/fa';
import { FiEdit } from 'react-icons/fi';
import { useDispatch } from 'react-redux';
import { deletePricing } from '../../redux/actions/frontendActions/pricingAction';

function DashboardPricingCard({price , index}) {
  const  dispatch =useDispatch();
    const [switchActive , setSwicthActive] =useState(false);

    const handleSwitch =(e) => {
     setSwicthActive(!switchActive)
    }
  return (
    <>
    <div className="dashboard-card-container"key={index}>
      <div className="card-wrapper dahboard-pricing-card-wrapper">
        <div className="icon-area">
            <AiOutlineCar/>
        </div>
        <div className="text-container">
            <div className="center-text">
            <h2 style={{fontSize: "18px"}}>{price.title}</h2>
            <p style={{color: "purple", padding:"10px 0", fontWeight:"bold"}}>category: {price.categories}</p>
          <p>
           {price.description.slice(0, 80)}
          </p>

          <div className="doller">
            <sup>$</sup><h1>{price.price}</h1><span> /month</span>
          </div>
            </div>
         
          <ul>
            {
              price.features.map((f, i)=> <li className='list-item-flex'>
              <div><CgChevronDoubleRight/></div>
              <div>{f}</div>
          </li>)
            }
           
           
          </ul>

          <div className="action-flex">
            <div className="edit">
              <FiEdit />
            </div>
            <div className="delete">
              <FaTrash onClick={() => dispatch(deletePricing(price._id))} />
            </div>
          </div>
        </div>
        <div className="swicth">
      <Switch name="switch" onChange={handleSwitch} label={switchActive? "Approved" : "Disapprove"} />
    </div>
      </div>
    
    </div>
    
   </>
  )
}

export default DashboardPricingCard